import { MEDIA } from "@/styles/common";
import { Center } from "@chakra-ui/react";
import { useSetGroupNameState, useSetPensionNameState } from "@shared/client";
import { BaseInfoResponse } from "@shared/server/apis/types";
import { useGetBaseInfo } from "@shared/server/hooks";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Footer } from "./footer";
import { Header } from "./header";

export const Layout = () => {
    const { data } = useGetBaseInfo<BaseInfoResponse>();
    const { pensionName } = { ...data };
    const setPensionName = useSetPensionNameState();
    const setGroupName = useSetGroupNameState();
    const { isMobile } = MEDIA();

    useEffect(() => {
        setPensionName(data?.pensionName);
        setGroupName(data?.group);
    }, [data]);

    return (
        <>
            <Header pensionName={pensionName} />
            <Center w="100%" padding={isMobile ? "24px 16px" : "64px 16px"} boxSizing="border-box">
                <Center maxWidth="1600px" width="100%" mt="120px">
                    <Outlet />
                </Center>
            </Center>
            <Footer />
        </>
    );
};
